import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import mapMediaTypeIcons from '../../../../admin/Scorecard/MediaContent/components/custom/mapMediaTypeIcons';

const mapType = mapMediaTypeIcons();

const TypeInList = ({ record }) => {
  const { type, mediaUrl, script } = record;
  return (
    <div>
      <a href={mediaUrl} target="_blank" rel="noreferrer">
        <img
          style={{ width: '30px' }}
          src={`/images/mediacontent/${mapType[type]}.png`}
          alt={type}
          title={type}
        />
      </a>
      {script?.mediaUrl && (
        <Tooltip title={(
          <>
            {script.name || ''} -
            {script.brandStatus === 'Approved' && (
              <>
                <IconButton size="small">
                  <i className="fa fa-check-square mx-1" style={{ fontSize: '0.8em', color: 'green' }} />
                </IconButton>
                Accepted
              </>
            )}
            {script.brandStatus === 'Rejected' && (
              <>
                <IconButton size="small">
                  <i className="fa fa-times mx-1" style={{ fontSize: '0.8em', color: 'red' }} />
                </IconButton>
                Rejected
              </>
            )}
            {!['Approved', 'Rejected'].includes(script.brandStatus) && (
              <>
                <IconButton size="small">
                  <i className="fa fa-exclamation-triangle mx-1" style={{ fontSize: '0.8em', color: 'yellow' }} />
                </IconButton>
                Missing
              </>
            )}
          </>
        )}>
          <a href={script.mediaUrl} target="_blank" rel="noreferrer">
            <img
              style={{ width: '30px' }}
              src={`/images/mediacontent/script.png`}
              alt="Script"
              className="ml-2"
            />
          </a>
        </Tooltip>
      )}
    </div>
  );
};
TypeInList.propTypes = {
  record: PropTypes.objectOf(PropTypes.any).isRequired,
};
export default TypeInList;
